export const legacyStyles = {
	header: {
		backgroundColor: '#e7ebed',
	},
	sidebar: {
		backgroundColor: '#1c345e',
		color: 'white',
	},
	button: {
		backgroundColor: '#cd1e27',
		color: '#fff',
		border: '1px solid #cd1e27',
		fontWeight: 600,
		':hover': {
			color: '#fff',
			backgroundColor: '#9a171d',
			borderColor: '#9a171d',
		},
	},
	title: {
		color: 'black',
	},
	text: {
		color: '#2c2c2c',
		buttonLoadingColor: '#FFFFFF',
	},
	table: {
		headerBackgroundColor: '#1c345e',
		headerTextColor: '#ffffff',
	},
	platformName: {
		name: 'DRIVE',
	},
	logo: {
		small: {
			// Will come from an s3 bucket eventually
			src: '/legacy/legacy-parking-icon-white.svg',
			height: 40,
			width: 40,
		},
		large: {
			src: '/legacy/legacy-parking-logo-tagline-white.svg',
			height: 65,
			width: 155,
		},
	},
	favicon: {
		src: '/legacy/legacy-parking-icon-red.svg',
	},
	socials: {
		facebook: 'https://www.facebook.com/legacyparking/',
		linkedIn: 'https://www.linkedin.com/company/legacy-parking-company/',
	},
	siteUrl: 'https://www.legacyparking.com/',
	orgName: 'Legacy Parking',
};
